import { render } from "./SCR030.vue?vue&type=template&id=fa13322c"
import script from "./SCR030.vue?vue&type=script&lang=ts"
export * from "./SCR030.vue?vue&type=script&lang=ts"
script.render = render

export default script